import { isSafeHttpUrl } from '@/lib/campaign-page-url'

/**
 * Normaliza uma URL vinda da API para uso em `href`/`src` de página pública.
 * Aceita só http(s) sem credenciais; qualquer outro esquema (javascript:, data:, etc.) vira `null`.
 */
export function safePublicHttpHref(value: string | null | undefined): string | null {
  const trimmed = value?.trim()
  if (!trimmed) {
    return null
  }

  return isSafeHttpUrl(trimmed) ? trimmed : null
}
